
<script>
import pubsub from 'pubsub-js'
import DataFModel from './DataModel/DataFModel'
import arrowUpRed from '@/assets/images/arrowUpRed.png'
import arrowUp from '@/assets/images/arrowUp.png'
import arrowDownRed from '@/assets/images/arrowDownRed.png'
import arrowDown from '@/assets/images/arrowDown.png'
export default {
  name: 'DataFList',
  data() {
    return {
      isShow: true,
      lcldata: [],
      loginInfo: null,
      visible: false,
      originArr: [],
      destArr: [],
      freightArr: [],
      mergeObj: {}, // 用来记录需要合并行的下标
      mergeArr: ['F_ExpenseCodeName'],// 表格中的列名
      isLoading: true,
      isHaveRecommend: false,
      twentyGpSort: '',
      fortyGpSort: '',
      fortyHqSort: '',
      fortyFiveHqSort: '',
      fortyNorSort: '',
    }
  },

  computed: {
    arrow() {
      return {
        arrowUp,
        arrowUpRed,
        arrowDown,
        arrowDownRed
      }
    }
  },

  mounted() {
    setTimeout(() => {
      this.isLoading = false
      this.$refs.hide.style.display = 'none'
    }, 1000)

    // 接收列表查询数据
    pubsub.subscribe('sendListData', (_, lcldata) => {
      let that = this
      let arr = lcldata.data
      this.isHaveRecommend = false
      for(let i=0;i<arr.length;i++){
        let temp = arr[i]
        if(temp.F_Recommend=='1'){
          that.isHaveRecommend = true
        }
      }
      this.lcldata = lcldata.data
    })

    this.loginInfo = window.localStorage.getItem('loginInfo')
  },

  methods: {
    // 获取详情数据
    async getDetailsInfo(id) {
      const {data: res} = await this.$http.post('Exportfcl/fclInfo', {
        FclId: id
      })
      try{
        if(res.code !== 200) {
          this.$message({
            message: res.info,
            type: 'error',
            duration: 2000
          })
        }else {
          pubsub.publish('details', [this.isShow, res.data])
        }
        
      }catch(error) {
        console.log(error)
      }
    },

    goToLogin() {
      this.$router.push({
        path: '/Login'
      })
    },

    twentyGpSortClick(){
      switch (this.twentyGpSort) {
        case '':
          this.twentyGpSort = 'asc'
          break;
        case 'asc':
          this.twentyGpSort = 'desc'
          break;
        case 'desc':
          this.twentyGpSort = ''
        default:
          break;
      }
      this.fortyGpSort = ''
      this.fortyHqSort = ''
      this.fortyFiveHqSort = ''
      this.fortyNorSort = ''
      this.getFclListData()
    },

    fortyGpSortClick(){
      switch (this.fortyGpSort) {
        case '':
          this.fortyGpSort = 'asc'
          break;
        case 'asc':
          this.fortyGpSort = 'desc'
          break;
        case 'desc':
          this.fortyGpSort = ''
        default:
          break;
      }
      this.twentyGpSort = ''
      this.fortyHqSort = ''
      this.fortyFiveHqSort = ''
      this.fortyNorSort = ''
      this.getFclListData()
    },

    fortyHqSortClick(){
      switch (this.fortyHqSort) {
        case '':
          this.fortyHqSort = 'asc'
          break;
        case 'asc':
          this.fortyHqSort = 'desc'
          break;
        case 'desc':
          this.fortyHqSort = ''
        default:
          break;
      }
      this.twentyGpSort = ''
      this.fortyGpSort = ''
      this.fortyFiveHqSort = ''
      this.fortyNorSort = ''
      this.getFclListData()
    },

    fortyFiveHqSortClick(){
      switch (this.fortyFiveHqSort) {
        case '':
          this.fortyFiveHqSort = 'asc'
          break;
        case 'asc':
          this.fortyFiveHqSort = 'desc'
          break;
        case 'desc':
          this.fortyFiveHqSort = ''
        default:
          break;
      }
      this.twentyGpSort = ''
      this.fortyGpSort = ''
      this.fortyHqSort = ''
      this.fortyNorSort = ''
      this.getFclListData()
    },

    fortyNorSortClick(){
      switch (this.fortyNorSort) {
        case '':
          this.fortyNorSort = 'asc'
          break;
        case 'asc':
          this.fortyNorSort = 'desc'
          break;
        case 'desc':
          this.fortyNorSort = ''
        default:
          break;
      }
      this.twentyGpSort = ''
      this.fortyGpSort = ''
      this.fortyHqSort = ''
      this.fortyFiveHqSort = ''
      this.getFclListData()
    },

     async getFclListData() {
      let param = JSON.parse(sessionStorage.getItem('paramData'))
      param.F_20GP = this.twentyGpSort
      param.F_40GP = this.fortyGpSort
      param.F_40HQ = this.fortyHqSort
      param.F_45HQ = this.fortyFiveHqSort
      param.F_40NOR = this.fortyNorSort
      sessionStorage.setItem('paramData',JSON.stringify(param))
      const {data: res} = await this.$http.post('Exportfcl/index', param)
      try{
        if(res.code !== 200) return this.$message({
          message: res.info, 
          duration: 2000, 
          type: 'error'
        })
        this.total = res.data.total
        this.currentPage = res.data.current_page
        this.pageSize = res.data.per_page
        this.lcldata = res.data.data
      }catch(error) {
        console.log(error)
      }      
    },

  },

  components: { 
    DataFModel 
  }
}
</script>
<template>
  <div class="DataList">
    <div class="DataList-box" v-show="lcldata.length > 0">
      <table>
        <thead style="background: #e9f0f7">
          <tr v-if="isHaveRecommend">
            <th>特色</th>
            <th>起运港</th>
            <th></th>
            <th>目的港</th>
            <th>船公司/舱位</th>
            <th>班期/开航</th>
            <th>航线代码/有效期</th>
            <th>
              <div class="sort-th" @click="twentyGpSortClick">
                20GP
                <span class="img-box">
                  <img 
                    :src="twentyGpSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="twentyGpSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyGpSortClick">
                40GP
                <span class="img-box">
                  <img 
                    :src="fortyGpSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyGpSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyHqSortClick">
                40HQ
                <span class="img-box">
                  <img 
                    :src="fortyHqSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyHqSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyFiveHqSortClick">
                45HQ
                <span class="img-box">
                  <img 
                    :src="fortyFiveHqSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyFiveHqSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th> 
              <div class="sort-th" @click="fortyNorSortClick">
                40NOR
                <span class="img-box">
                  <img 
                    :src="fortyNorSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyNorSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div> 
            </th>
            <th></th>
          </tr>
          <tr v-if="!isHaveRecommend">
            <th>起运港</th>
            <th></th>
            <th>目的港</th>
            <th>船公司/舱位</th>
            <th>班期/开航</th>
            <th>航线代码/有效期</th>
            <th>
              <div class="sort-th" @click="twentyGpSortClick">
                20GP
                <span class="img-box">
                  <img 
                    :src="twentyGpSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="twentyGpSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyGpSortClick">
                40GP
                <span class="img-box">
                  <img 
                    :src="fortyGpSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyGpSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyHqSortClick">
                40HQ
                <span class="img-box">
                  <img 
                    :src="fortyHqSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyHqSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th>
              <div class="sort-th" @click="fortyFiveHqSortClick">
                45HQ
                <span class="img-box">
                  <img 
                    :src="fortyFiveHqSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyFiveHqSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div>
            </th>
            <th> 
              <div class="sort-th" @click="fortyNorSortClick">
                40NOR
                <span class="img-box">
                  <img 
                    :src="fortyNorSort === 'asc' ? arrow.arrowUpRed : arrow.arrowUp" 
                    class="sort-img"
                  />
                  <img 
                    :src="fortyNorSort === 'desc' ? arrow.arrowDownRed : arrow.arrowDown"
                    class="sort-img"
                  />
                </span>
              </div> 
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in lcldata" :key="d.F_Id">
            <td v-if="d.F_Recommend=='1' && isHaveRecommend">
              <img style="width: 26px;height: 26px;" src="@/assets/images/fire.gif">
            </td>
            <td v-if="d.F_Recommend!='1' && isHaveRecommend">
              <view style="width: 26px;height: 26px;background-color: none;"/>
            </td>
            <td>
              <h3 class="city-en">{{ d.FromPortEnglish }}</h3>
              <p class="city-zh">{{ d.FromPortName }}</p>
            </td>
            <td>
              <div class="lcl-info">
                <span class="lcl-day">{{ d.F_Voyage? d.F_Voyage : '--' }}天</span>
                <i class="line"></i>
                <span class="lcl-type">
                  {{ d.TransitPortEnglish === null ? '直达' : d.TransitPortEnglish }}
                </span>
              </div>
            </td>
            <td>
              <h3 class="city-en">{{ d.ToPortEnglish }}</h3>
              <p class="city-zh">{{ d.ToPortName }}</p>
            </td>
            <td>
              <p class="take-type">{{ d.F_ShoppingCompany? d.F_ShoppingCompany : '--' }}</p>
              <p class="lcl-rt">{{ d.F_ShippingSpace? d.F_ShippingSpace : '--' }}</p>
            </td>
            <td>
              <p class="lcl-week">
                {{ d.F_ShiftPeriod? d.F_ShiftPeriod : '--' }}
              </p>
              <p class="lcl-week" style="margin-top: -15px">
                {{ d.ConsigneeTypeName? d.ConsigneeTypeName : '--' }}
              </p>
            </td>
            <td>
              <!-- <p>{{ d.F_RouteCode? d.F_RouteCode : '--' }}</p> -->
              <p class="lcl-date">{{ d.F_StartTime }} 至 {{ d.F_EndTime }}</p>
            </td>
            <td>
              <div v-if="loginInfo">
                <span class="ton">{{d.F_20GP?  '$'+d.F_20GP : '--'}}</span>
              </div>
              <div v-else>****</div>
            </td>
            <td>
              <div v-if="loginInfo">
                <span class="ton">{{d.F_40GP? '$'+d.F_40GP : '--'}}</span>
              </div>
              <div v-else>****</div>
            </td>
            <td>
              <div v-if="loginInfo">
                <span class="ton">{{d.F_40HQ? '$'+d.F_40HQ : '--'}}</span>
              </div>
              <div v-else>****</div>
            </td>
            <td>
              <div v-if="loginInfo">
                <span class="ton">{{d.F_45HQ? '$'+d.F_45HQ : '--'}}</span>
              </div>
              <div v-else>****</div>
            </td>
            <td>
              <div v-if="loginInfo">
                <span class="ton">{{d.F_40NOR? '$'+d.F_40NOR : '--'}}</span>
              </div>
              <div v-else>****</div>
            </td>
            <td>
              <div class="lcl-btn">
                <el-button
                  style="background: #0081ff" 
                  type="primary" 
                  size="mini"
                  @click="getDetailsInfo(d.F_Id)"
                  v-if="loginInfo !== null"
                >
                  详情
                </el-button>
                <el-button
                  type="success"
                  size="mini"
                  v-else @click="goToLogin"
                >
                  登录
                </el-button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <slot name="pageContent"></slot>
    </div>
    <div class="public-empty" v-show="lcldata.length <= 0">
      <div class="public-loading" ref="hide" v-loading="isLoading" element-loading-text="拼命查询中..."></div>
      <div class="public-empty-text">
        <div class="el-icon-warning"></div>
        <p>暂无搜索数据</p>
      </div>
    </div>
    <Data-F-Model></Data-F-Model>
  </div>
</template>

<style scoped lang="less">

.DataList {
  width: 1280px;
  margin: 20px auto 0 auto;
  background: #fff;
  padding: 0 0;
  box-sizing: border-box;
  margin-bottom: 230px;

  .sort-th {
    cursor: pointer;
    user-select: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .img-box {
    display: flex;
    flex-direction: column;
    line-height: 1;
  }
  .sort-img {
    width: 7px;
    height: 7px;
    opacity: 1; 
    transition: opacity 0.2s;
  }

  .pagesBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;
  }

  .public-empty {
    position: relative;
    height: 360px;

    .public-loading {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: #fff;
    }

    .public-empty-text {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 70px;
    }

    .el-icon-warning {
      font-size: 88px;
      color: #d2d3e3;
    }

    p {
      color: #5a5d71;
      font-size: 16px;
      margin: 10px 0;
    }
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    box-sizing: border-box;
    // table-layout: fixed;

    tr {
      &:nth-child(even) {
        background: #e9f0f7;
      }
    }

    th,
    td {
      height: 40px;
      font-size: 13px;
      color: #697e9d;
      border-bottom: 1px solid #eee;
      text-align: left;
      line-height: 40px;
      padding: 10px 15px;
      font-weight: 500;

      .city-en {
        font-size: 13px;
        font-weight: 550;
      }

      .city-zh {
        margin-top: -20px;
        font-size: 12px;
      }

      .lcl-info {
        width: 90px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-left: -20px;

        .line {
          position: relative;
          display: block;
          width: 80px;
          border: 1px solid #ccc;
          margin-top: -6px;
          &::before {
            position: absolute;
            top: 50%;
            left: -2px;
            transform: translateY(-50%);
            display: block;
            content: '';
            width: 8px;
            height: 8px;
            background: #ccc;
            border-radius: 100%;
          }

          &::after {
            position: absolute;
            top: 50%;
            right: -2px;
            transform: translateY(-50%);
            display: block;
            content: '';
            width: 8px;
            height: 8px;
            background: #ccc;
            border-radius: 100%;
          }
        }

        .lcl-day,
        .lcl-type {
          display: block;
          font-size: 12px;
        }

        .lcl-type {
          width: 120px;
          margin-top: -6px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
      }

      .ton, .cbm {
        color: #f53;
        font-weight: 550;
      }

      .take-type {
        font-size: 13px;
      }

      .lcl-rt {
        margin-top: -20px;
        font-size: 12px;
        color: #0081ff;
        font-weight: 550;
      }
      .lcl-week, .lcl-ship {
        font-size: 12px;
      }

      .lcl-ship {
        margin-top: -20px;
      }

      .lcl-btn {
        display: flex;
        justify-content: center;
      }

      .lcl-pay {
        display: flex;
        a {
          font-size: 12px;
          margin-right: 5px;
          white-space: nowrap;
          color: #0081ff;
          &:hover {
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
      .lcl-date {
          font-size: 12px;
          white-space: nowrap;
          
        }
    }
  }
}</style>